import(/* webpackMode: "eager" */ "/app/src/app/[locale]/padel-master-the-game/page.tsx");
